import usePipelineStore from '../../../stores/pipeline-store';
import { CreateDashboardSettings } from './settings/CreateDashboardSettings';
import { ExternalRequestStepSettings } from './settings/ExternalRequestStepSettings';
import { FinishStepSettings } from './settings/FinishStepSettings';
import { GenerateStoryStepSettings } from './settings/GenerateStoryStepSettings';
import { GetAnswerValuesStepSettings } from './settings/GetAnswerValuesStepSettings';
import { ModeratorInputStepSettings } from './settings/ModeratorInputStepSettings';
import { SendMessageStepSettings } from './settings/SendMessageStepSettings';
import { SetVarStepSettings } from './settings/SetVarStepSettings';
import { SurveyLinkStepSettings } from './settings/SurveyLinkStepSettings';

const SETTINGS_BY_STEP_TYPE: Partial<Record<PipelineStep['type'], React.FC<{ stepId: string }>>> = {
    SEND_MESSAGE: SendMessageStepSettings,
    CREATE_SURVEY_LINK: SurveyLinkStepSettings,
    GET_ANSWER_VALUES: GetAnswerValuesStepSettings,
    SET_VAR: SetVarStepSettings,
    GENERATE_STORY: GenerateStoryStepSettings,
    MODERATOR_INPUT: ModeratorInputStepSettings,
    EXTERNAL_REQUEST: ExternalRequestStepSettings,
    FINISH: FinishStepSettings,
    CREATE_DASHBOARD: CreateDashboardSettings,
};

type StepDrawerSettingsAccordionItemProps = {
    stepId: string;
};

export function StepDrawerSettingsAccordionItem({ stepId }: StepDrawerSettingsAccordionItemProps) {
    const { pipeline } = usePipelineStore((state) => state);
    const step = pipeline.steps[stepId] as PipelineStep;

    const Component = step?.type ? SETTINGS_BY_STEP_TYPE[step.type] : null;
    if (Component) {
        return <Component stepId={stepId} />;
    }
    return null;
}
